import { render, staticRenderFns } from "./TipoDocumentoPage.vue?vue&type=template&id=27d8fb2f"
import script from "./TipoDocumentoPage.js?vue&type=script&lang=js&external"
export * from "./TipoDocumentoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports